/*
 * qrPayload.js — one place that understands what a Join-a-Team QR carries.
 *
 * Real-world finding (iPhone field test): the native camera treats a bare-text
 * QR as a web search. So the printed QR encodes a LINK to the app with the
 * tenant id as a query param — the native camera then opens Flow directly.
 * The in-app scanner accepts BOTH forms. Either way the payload carries the
 * tenant id only — never identity, permissions, or credentials
 * ("Arrival, Not Authentication").
 *
 *   bare id:  test-construction-co
 *   link:     https://<app-domain>/?t=test-construction-co
 */
export function parseTenantPayload(text) {
  const raw = String(text || '').trim()
  if (!raw) return null
  if (/^https?:\/\//i.test(raw)) {
    try {
      const url = new URL(raw)
      const t = url.searchParams.get('t')
      if (t && t.trim()) return t.trim()
      // Tolerate a path form (/join/<id>) in case a future QR uses it.
      const segs = url.pathname.split('/').filter(Boolean)
      if (segs[0] === 'join' && segs[1]) return decodeURIComponent(segs[1])
      return null // a URL without a tenant marker is not a Flow code
    } catch {
      return null
    }
  }
  return raw // bare tenant id or company code
}

/** Read a tenant deep link (?t=...) from the current location, if present. */
export function tenantFromLocation(loc = window.location) {
  try {
    return new URLSearchParams(loc.search).get('t')?.trim() || null
  } catch {
    return null
  }
}
